<div class="gastos-container">
  <h1 class="gastos-titulo">Gastos</h1>

  <mat-tab-group>
    <!-- ════════════════ MES ACTUAL ════════════════ -->
    <mat-tab label="Mes en curso ({{ mesActualNombre }})">
      <section class="gastos-seccion gastos-tab-content">
        <h2 class="gastos-subtitulo">
          <mat-icon>trending_up</mat-icon>
          Facturación en curso
        </h2>

        @if (loadingFacturacion) {
          <div class="gastos-loading">
            <mat-spinner diameter="40"></mat-spinner>
          </div>
        } @else if (facturacion && chartFacturacion) {
          <div class="gastos-totales">
            <div class="gastos-total-box gastos-total-box--estimado">
              <span class="gastos-total-label">
                Mes Anterior ({{ mesAnteriorNombre }})
              </span>
              <span class="gastos-total-valor">
                {{ facturacion.mesPasado.total || 0 | number }} disp.
              </span>
            </div>
            <div class="gastos-total-box gastos-total-box--real">
              <span class="gastos-total-label">
                Consolidado ({{ mesActualNombre }})
              </span>
              <span class="gastos-total-valor">
                {{ facturacion.totalReal || 0 | number }} disp.
              </span>
            </div>
          </div>

          <app-chart-card [config]="chartFacturacion"></app-chart-card>

          <!-- Cantidades y costos por categoría -->
          <h3 class="gastos-subtitulo-3">
            <mat-icon>format_list_numbered</mat-icon>
            Detalle por categoría (Consolidado)
          </h3>
          <mat-card class="gastos-card">
            <table class="gastos-tabla">
              <thead>
                <tr>
                  <th>Categoría</th>
                  <th>Consolidados / Total</th>
                  <th>Mes anterior (disp.)</th>
                </tr>
              </thead>
              <tbody>
                @for (cat of categorias; track cat.key) {
                  <tr>
                    <td>{{ cat.label }}</td>
                    <td>
                      {{ facturacion[cat.key].activos | number }} /
                      {{ facturacion[cat.key].total | number }}
                    </td>
                    <td>
                      {{ facturacion.mesPasado[cat.key] || 0 | number }}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </mat-card>

          <!-- Gasto que generan los hijos -->
          @if (hijosMayoristas.length || clientesFinales) {
            <h3 class="gastos-subtitulo-3">
              <mat-icon>account_tree</mat-icon>
              Gasto que generan tus clientes hijos
            </h3>
            <mat-card class="gastos-card">
              <div class="gastos-tabla-scroll">
                <table class="gastos-tabla gastos-tabla--sortable">
                  <thead>
                    <tr>
                      <th
                        class="irx-clickeable"
                        role="button"
                        tabindex="0"
                        (click)="ordenarHijos('nombre')"
                        (keydown.enter)="ordenarHijos('nombre')"
                      >
                        Cliente
                        @if (ordenHijosCampo === 'nombre') {
                          <mat-icon class="orden-icono">
                            {{
                              ordenHijosDir === 'asc'
                                ? 'arrow_upward'
                                : 'arrow_downward'
                            }}
                          </mat-icon>
                        }
                      </th>
                      <th
                        class="irx-clickeable"
                        role="button"
                        tabindex="0"
                        (click)="ordenarHijos('costoPasado')"
                        (keydown.enter)="ordenarHijos('costoPasado')"
                      >
                        Mes anterior (disp.)
                        @if (ordenHijosCampo === 'costoPasado') {
                          <mat-icon class="orden-icono">
                            {{
                              ordenHijosDir === 'asc'
                                ? 'arrow_upward'
                                : 'arrow_downward'
                            }}
                          </mat-icon>
                        }
                      </th>
                      <th
                        class="irx-clickeable"
                        role="button"
                        tabindex="0"
                        (click)="ordenarHijos('costoReal')"
                        (keydown.enter)="ordenarHijos('costoReal')"
                      >
                        Consolidado (disp.)
                        @if (ordenHijosCampo === 'costoReal') {
                          <mat-icon class="orden-icono">
                            {{
                              ordenHijosDir === 'asc'
                                ? 'arrow_upward'
                                : 'arrow_downward'
                            }}
                          </mat-icon>
                        }
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (h of hijosMayoristasOrdenados; track h.idCliente) {
                      <tr
                        class="gastos-fila-expandible irx-clickeable"
                        role="button"
                        tabindex="0"
                        (click)="toggleHijo(h.idCliente)"
                        (keydown.enter)="toggleHijo(h.idCliente)"
                      >
                        <td>
                          <mat-icon class="expand-icono">
                            {{
                              hijosExpandidos.has(h.idCliente)
                                ? 'expand_less'
                                : 'expand_more'
                            }}
                          </mat-icon>
                          {{ h.nombre }}
                          <small>(Mayorista)</small>
                        </td>
                        <td>{{ h.costoPasado || 0 | number }}</td>
                        <td>{{ h.costoReal || 0 | number }}</td>
                      </tr>
                      @if (hijosExpandidos.has(h.idCliente)) {
                        <tr class="gastos-fila-cantidades">
                          <td colspan="3">
                            <div class="gastos-cantidades-mini">
                              <span class="gastos-cantidades-titulo">
                                Consolidado:
                              </span>
                              <span>
                                <strong>Trackers:</strong>
                                {{
                                  h.cantidades?.trackers?.activos ?? 0 | number
                                }}
                              </span>
                              <span>
                                <strong>Alarmas:</strong>
                                {{
                                  h.cantidades?.alarmas?.activos ?? 0 | number
                                }}
                              </span>
                              <span>
                                <strong>Cámaras:</strong>
                                {{ h.cantidades?.camaras?.total ?? 0 | number }}
                              </span>
                            </div>
                            @if (h.pasado) {
                              <div class="gastos-cantidades-mini">
                                <span class="gastos-cantidades-titulo">
                                  Mes anterior:
                                </span>
                                <span>
                                  <strong>Trackers:</strong>
                                  {{
                                    h.pasado.trackers?.cantidad ?? 0 | number
                                  }}
                                </span>
                                <span>
                                  <strong>Alarmas:</strong>
                                  {{ h.pasado.alarmas?.cantidad ?? 0 | number }}
                                </span>
                                <span>
                                  <strong>Cámaras:</strong>
                                  {{ h.pasado.camaras?.cantidad ?? 0 | number }}
                                </span>
                              </div>
                            }
                          </td>
                        </tr>
                      }
                    }
                    @if (clientesFinales) {
                      <tr
                        class="gastos-fila-finales gastos-fila-expandible irx-clickeable"
                        role="button"
                        tabindex="0"
                        (click)="toggleHijo('finales')"
                        (keydown.enter)="toggleHijo('finales')"
                      >
                        <td>
                          <mat-icon class="expand-icono">
                            {{
                              hijosExpandidos.has('finales')
                                ? 'expand_less'
                                : 'expand_more'
                            }}
                          </mat-icon>
                          Clientes finales
                          <small>
                            ({{ clientesFinales.cantidad | number }})
                          </small>
                        </td>
                        <td>{{ clientesFinales.costoPasado || 0 | number }}</td>
                        <td>{{ clientesFinales.costoReal || 0 | number }}</td>
                      </tr>
                      @if (hijosExpandidos.has('finales')) {
                        <tr class="gastos-fila-cantidades">
                          <td colspan="3">
                            <div class="gastos-cantidades-mini">
                              <span class="gastos-cantidades-titulo">
                                Consolidado:
                              </span>
                              <span>
                                <strong>Trackers:</strong>
                                {{
                                  clientesFinales.cantidades?.trackers
                                    ?.activos ?? 0 | number
                                }}
                              </span>
                              <span>
                                <strong>Alarmas:</strong>
                                {{
                                  clientesFinales.cantidades?.alarmas
                                    ?.activos ?? 0 | number
                                }}
                              </span>
                              <span>
                                <strong>Cámaras:</strong>
                                {{
                                  clientesFinales.cantidades?.camaras?.total ??
                                    0 | number
                                }}
                              </span>
                            </div>
                            @if (clientesFinales.pasado; as pasado) {
                              <div class="gastos-cantidades-mini">
                                <span class="gastos-cantidades-titulo">
                                  Mes anterior:
                                </span>
                                <span>
                                  <strong>Trackers:</strong>
                                  {{ pasado.trackers?.cantidad ?? 0 | number }}
                                </span>
                                <span>
                                  <strong>Alarmas:</strong>
                                  {{ pasado.alarmas?.cantidad ?? 0 | number }}
                                </span>
                                <span>
                                  <strong>Cámaras:</strong>
                                  {{ pasado.camaras?.cantidad ?? 0 | number }}
                                </span>
                              </div>
                            }
                          </td>
                        </tr>
                      }
                    }
                  </tbody>
                </table>
              </div>
            </mat-card>
          }

          <!-- Bonificados -->
          @if (facturacion.bonificados.length) {
            <h3 class="gastos-subtitulo-3">
              <mat-icon>card_giftcard</mat-icon>
              Clientes bonificados (descontados del total)
            </h3>
            <mat-card class="gastos-card">
              <table class="gastos-tabla">
                <thead>
                  <tr>
                    <th>Cliente</th>
                    <th>Tipo</th>
                    <th>Bonificado total (disp.)</th>
                    <th>Bonificado consolidado (disp.)</th>
                  </tr>
                </thead>
                <tbody>
                  @for (b of facturacion.bonificados; track b.idCliente) {
                    <tr>
                      <td>{{ b.nombre }}</td>
                      <td>{{ b.tipoCliente }}</td>
                      <td>{{ b.costoEstimado || 0 | number }}</td>
                      <td>{{ b.costoReal || 0 | number }}</td>
                    </tr>
                  }
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan="2"><strong>Total bonificado</strong></td>
                    <td>
                      <strong>
                        {{
                          facturacion.bonificacion.totalEstimado || 0 | number
                        }}
                      </strong>
                    </td>
                    <td>
                      <strong>
                        {{ facturacion.bonificacion.totalReal || 0 | number }}
                      </strong>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </mat-card>
          }
        } @else {
          <p class="gastos-vacio">No hay datos de facturación en curso.</p>
        }
      </section>
    </mat-tab>

    <!-- ════════════════ HISTÓRICO ════════════════ -->
    <mat-tab label="Histórico">
      <section class="gastos-seccion gastos-tab-content">
        @if (loadingHistorial) {
          <div class="gastos-loading">
            <mat-spinner diameter="40"></mat-spinner>
          </div>
        } @else if (historial.length) {
          <div class="gastos-historico-controls">
            <span class="gastos-historico-hint">
              Mes final del período (6 meses):
            </span>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>Mes</mat-label>
              <mat-select
                [(ngModel)]="mesSel"
                (selectionChange)="onVentanaChange()"
              >
                @for (m of mesesOpciones; track m.valor) {
                  <mat-option [value]="m.valor">{{ m.nombre }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>Año</mat-label>
              <mat-select
                [(ngModel)]="anioSel"
                (selectionChange)="onVentanaChange()"
              >
                @for (a of aniosOpciones; track a) {
                  <mat-option [value]="a">{{ a }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          @if (chartHistorico) {
            <app-chart-card [config]="chartHistorico"></app-chart-card>
          }

          @for (slot of mesesSlotsDescendente; track slot.label) {
            @if (slot.resumen; as resumen) {
              <mat-card class="gastos-card">
                <div class="gastos-card-header">
                  <span class="gastos-periodo">
                    {{ resumen.periodoInicio | date: 'dd/MM/yyyy' }} —
                    {{ resumen.periodoFin | date: 'dd/MM/yyyy' }}
                  </span>
                  <span class="gastos-header-derecha">
                    <span class="gastos-total">
                      {{ resumen.resumen?.total || 0 | number }} disp.
                    </span>
                    <button
                      irxBotonIcono
                      tooltip="Exportar a PDF"
                      (click)="exportarMes(resumen, slot.label)"
                    >
                      <mat-icon>picture_as_pdf</mat-icon>
                    </button>
                    <button
                      irxBotonIcono
                      tooltip="Exportar a Excel"
                      (click)="exportarMesExcel(resumen, slot.label)"
                    >
                      <mat-icon>table_view</mat-icon>
                    </button>
                  </span>
                </div>

                <table class="gastos-tabla">
                  <thead>
                    <tr>
                      <th>Categoría</th>
                      <th>Facturados</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (cat of categorias; track cat.key) {
                      <tr>
                        <td>{{ cat.label }}</td>
                        <td>
                          {{
                            resumen.resumen?.[cat.key]?.cantidadFacturada || 0
                              | number
                          }}
                        </td>
                        <td>
                          {{
                            resumen.resumen?.[cat.key]?.cantidadTotal || 0
                              | number
                          }}
                        </td>
                      </tr>
                    }
                    <tr class="gastos-tabla-total">
                      <td><strong>Total dispositivos</strong></td>
                      <td>
                        <strong>
                          {{ resumen.resumen?.total || 0 | number }}
                        </strong>
                      </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>

                <!-- Desglose por cliente hijo guardado en el resumen -->
                @if (resumen.resumen?.hijos?.length) {
                  <mat-expansion-panel class="gastos-hijos-panel">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        Detalle por cliente ({{
                          resumen.resumen?.hijos?.length
                        }})
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    <ng-template matExpansionPanelContent>
                      <app-detalle-clientes-resumen
                        [hijos]="resumen.resumen?.hijos ?? []"
                      ></app-detalle-clientes-resumen>
                    </ng-template>
                  </mat-expansion-panel>
                }
              </mat-card>
            } @else {
              <mat-card class="gastos-card gastos-card--sin">
                <div class="gastos-card-header">
                  <span class="gastos-periodo">{{ slot.label }}</span>
                  <span class="gastos-sin-resumen">Sin resumen</span>
                </div>
              </mat-card>
            }
          }
        } @else {
          <p class="gastos-vacio">No hay gastos registrados.</p>
        }
      </section>
    </mat-tab>
  </mat-tab-group>
</div>
